export enum ImageLoadingState {
    NONE = "NONE",
    LOADING = "LOADING",
    LOADED = "LOADED",
    ERROR = "ERROR"
}